import './style.scss'
import { useContext, useState } from "react"
import ApiContext from 'src/provider/API/call-service'
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, FormGroup } from "src/style"
import { BsEyeSlash, BsEye } from 'react-icons/bs'
import { useNotifier } from "react-pop-notifier"

export const Privacy: React.FC<any> = () => {
    const {API} = useContext(ApiContext)
    const {notifier} = useNotifier()
    const [input, setInput] = useState({
        password: '**********', oldPassword: '', newPassword: '', confirmPassword: ''
    })
    const [showPassword, setShowPassword] = useState({password: false, oldPassword: false, newPassword: false, confirmPassword: false})
    const [isChangePassword, setIsChangePassword] = useState(false)

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handlePasswordChange () {
        if (input.newPassword !== input.confirmPassword) return notifier.show('Password confirmation does not match')
        const response = await API.changePassword(input)
        if (response) {
            setIsChangePassword(false)
        }
    }
    
    return (
        <CustomContainer 
            topMargin="5"
        >
            <CustomContainer
                bottomPadding="2.5"
                style={{borderBottom: '1px solid #EDF1F4'}}
            >
                <AppSpan 
                    textSize="1.6" color="#181D27" fontWeight="700"
                >
                    Privacy
                </AppSpan>
            </CustomContainer>

            <FlexRow 
                topMargin="3" wrap="wrap" 
                alignItems="flex-start"
                justifyContent='space-between'
                gap="4" bottomPadding="3.5"
            >
                <CustomContainer width="auto" sizeUnit=''>
                    <AppSpan 
                        textSize="1.6" fontWeight="700" 
                        color="#1D1D1D"
                    >
                        Password
                    </AppSpan>
                    <AppText 
                        textSize="1.6" color="#4F4F4F"
                    >
                        Orci, porttitor feugiat sociis qui.
                    </AppText>
                </CustomContainer>
                <CustomContainer width='28'>
                    <FormGroup>
                        <label>Password</label>
                        <input 
                            value={input.password}
                            type={showPassword.password ? 'text' : 'password'}
                            disabled
                        />
                        { !showPassword.password ?
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowPassword({...showPassword, password: true})}
                                >
                                    <BsEyeSlash/>
                                </AppSpan>
                            </AbsoluteContainer>
                            :
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowPassword({...showPassword, password: false})}
                                >
                                    <BsEye/>
                                </AppSpan>
                            </AbsoluteContainer>
                        }
                    </FormGroup>
                    { !isChangePassword &&
                        <AppSpan 
                            textSize='1.6' fontWeight='600' 
                            color='#5627FF' cursor='pointer'
                            hoverColor='#ABABAB'
                            onClick={() => setIsChangePassword(true)}
                        >
                            Change Password &gt;
                        </AppSpan>
                    }
                    { isChangePassword &&
                        <CustomContainer 
                            topPadding='2.5'
                            style={{borderTop: '1px solid #E7EBEE'}}
                        >
                            <FormGroup>
                                <label>Old Password</label>
                                <input 
                                    placeholder='Enter Old Password'
                                    name='oldPassword' 
                                    type={showPassword.oldPassword ? 'text' : 'password'}
                                    value={input.oldPassword}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                                { !showPassword.oldPassword ?
                                    <AbsoluteContainer bottom='1.2' right='1'>
                                        <AppSpan 
                                            color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                            onClick={() => setShowPassword({...showPassword, oldPassword: true})}
                                        >
                                            <BsEyeSlash/>
                                        </AppSpan>
                                    </AbsoluteContainer>
                                    :
                                    <AbsoluteContainer bottom='1.2' right='1'>
                                        <AppSpan 
                                            color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                            onClick={() => setShowPassword({...showPassword, oldPassword: false})}
                                        >
                                            <BsEye/>
                                        </AppSpan>
                                    </AbsoluteContainer>
                                }
                            </FormGroup>
                            <FormGroup>
                                <label>New Password</label>
                                <input 
                                    placeholder='Enter New Password'
                                    name='newPassword' 
                                    type={showPassword.newPassword ? 'text' : 'password'}
                                    value={input.newPassword}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                                { !showPassword.newPassword ?
                                    <AbsoluteContainer bottom='1.2' right='1'>
                                        <AppSpan 
                                            color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                            onClick={() => setShowPassword({...showPassword, newPassword: true})}
                                        >
                                            <BsEyeSlash/>
                                        </AppSpan>
                                    </AbsoluteContainer>
                                    :
                                    <AbsoluteContainer bottom='1.2' right='1'>
                                        <AppSpan 
                                            color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                            onClick={() => setShowPassword({...showPassword, newPassword: false})}
                                        >
                                            <BsEye/>
                                        </AppSpan>
                                    </AbsoluteContainer>
                                }
                            </FormGroup>
                            <FormGroup bottomMargin='3'>
                                <label>Confirm Password</label>
                                <input 
                                    placeholder='Confirm Password'
                                    name='confirmPassword' 
                                    type={showPassword.confirmPassword ? 'text' : 'password'}
                                    value={input.confirmPassword}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                                { !showPassword.confirmPassword ?
                                    <AbsoluteContainer bottom='1.2' right='1'>
                                        <AppSpan 
                                            color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                            onClick={() => setShowPassword({...showPassword, confirmPassword: true})}
                                        >
                                            <BsEyeSlash/>
                                        </AppSpan>
                                    </AbsoluteContainer>
                                    :
                                    <AbsoluteContainer bottom='1.2' right='1'>
                                        <AppSpan 
                                            color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                            onClick={() => setShowPassword({...showPassword, confirmPassword: false})}
                                        >
                                            <BsEye/>
                                        </AppSpan>
                                    </AbsoluteContainer>
                                }
                            </FormGroup>

                            <FlexRow 
                                justifyContent="flex-end" 
                                gap="1"
                            >
                                <Button 
                                    width='12.3' 
                                    hoverBgColor='#ffffff'
                                    bgColor="#ffffff" 
                                    hoverBorderColor='#5627FF'
                                    hoverColor='#5627FF'
                                    color="#5627FF"
                                    onClick={() => setIsChangePassword(false)}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    width='12.3' 
                                    hoverBgColor='#ffffff' 
                                    hoverColor='#5627FF'
                                    borderColor='#5627FF'
                                    onClick={handlePasswordChange}
                                >
                                    Next
                                </Button>
                            </FlexRow>
                        </CustomContainer>
                    }
                </CustomContainer>

                <CustomContainer width='auto' sizeUnit=''>
                    <AppSpan textSize='1.6' fontWeight='700' 
                        color='#000000'
                    >
                        Permission and Access Level Status
                    </AppSpan>

                    <CustomContainer 
                        width='auto' sizeUnit='' 
                        topMargin='3'
                    >
                        <AppSpan textSize='1.6' color='#ABABAB'>
                            Admin Role
                        </AppSpan>
                        <AppText 
                            textSize='1.6' fontWeight='700' 
                            color='#000000'
                        >
                            Super Admin
                        </AppText>
                    </CustomContainer>
                    <CustomContainer 
                        width='auto' sizeUnit='' 
                        topMargin='3'
                    >
                        <AppSpan textSize='1.6' color='#ABABAB'>
                            Admin Permission
                        </AppSpan>
                        <AppText 
                            textSize='1.6' fontWeight='700' 
                            color='#000000'
                        >
                            Full Access
                        </AppText>
                    </CustomContainer>
                </CustomContainer>
            </FlexRow>
        </CustomContainer>
    )
}